<script lang="ts">
  let cs: string = 'bg-secondary h-[12px] rounded-full';

  export { cs as class };
</script>

<div class="w-full animate-pulse {cs}" />